import UsersAutocomplete from '../../../../../shared/users-autocomplete';

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Typography from '@mui/material/Typography';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Box from '@mui/material/Box';
import WorkspacePremium from '@mui/icons-material/WorkspacePremium';

export default function GmailExportEnterpriseAlert() {
  return (
    <Alert severity="info" icon={<WorkspacePremium />}>
      <AlertTitle>Enterprise Feature</AlertTitle>
      <Typography>
        Automatically adding the Gmail export on completion to a user's Google
        Drive is an Enterprise feature.
      </Typography>
      <FormLabel component="legend" sx={{ mt: 1 }}>
        Destination User:
      </FormLabel>
      <RadioGroup>
        <FormControlLabel
          value="manager"
          control={<Radio />}
          label="Manager"
          disabled
        />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'start',
            gap: 1,
          }}
        >
          <FormControlLabel
            value="custom"
            control={<Radio />}
            label="Custom User:"
            disabled
          />
          <Box sx={{ width: 300 }}>
            <UsersAutocomplete
              autocompleteValue={''}
              setAutoCompleteValue={() => {}}
              errors={false}
              helperText={undefined}
              disabled={true}
            />
          </Box>
        </Box>
      </RadioGroup>
    </Alert>
  );
}
